/* Haken — selector de vehículo (marca / modelo / año / versión)
 * Reemplaza al selector de haken.js: se carga ANTES y neutraliza el viejo
 * renombrando [data-hk-vehiculo], para que no se dupliquen las opciones.
 * Datos: window.HAKEN_VEHICULOS (metafield de tienda haken.catalogo_vehiculos).
 * Una sección sólo usa su propio JSON si trae data-hk-lista-propia.
 *
 * El vehículo elegido se comparte entre todos los selectores del sitio:
 *   1. Se guarda en el navegador (localStorage / sessionStorage).
 *   2. Además viaja en los enlaces internos como #hkv=... para que llegue a la
 *      siguiente página aunque el navegador no comparta el almacenamiento
 *      (editor de Shopify, modo privado, Safari).
 *   3. Al regresar con Atrás o cambiar en otra pestaña se vuelve a leer.
 *
 * CONTRATO PÚBLICO
 *   window.HakenVehiculo.get() / .limpiar() / .catalogo() / .linea()
 *   evento 'haken:vehiculo' en document, detail = vehículo o null
 *
 * WHATSAPP: cada enlace a wa.me lleva un mensaje con el vehículo.
 *   - Botón dentro de un servicio (.hk-serv) o con data-hk-servicio="...": agenda ese servicio.
 *   - Botones que dicen "Agendar" (o data-hk-wa="agenda"): pregunta por espacios.
 *   - El resto: pide información del producto.
 *   - La primera línea indica el origen: "Web" o "Web (Instagram)", "Web (Facebook)", etc.
 */
(function () {
  'use strict';

  var LLAVE = 'haken_veh';
  var CARR = { PM: 'Pickup mediana', PG: 'Pickup grande', SU: 'SUV', CR: 'Crossover', SE: 'Sedán',
               HA: 'Hatchback', VC: 'Van de carga', VP: 'Van de pasajeros', CC: 'Chasis-cabina' };
  var MOTOR = { G: 'Gasolina o diésel', H: 'Híbrido', E: 'Eléctrico' };
  var COMBUSTIBLE = { G: 'de gasolina o diésel', H: 'híbrido', E: 'eléctrico' };
  var PRODUCTO_TIRON = {
    premium: 'el tirón para vehículo premium',
    estandar: 'el tirón Línea Estándar',
    anteriores: 'el tirón para modelos anteriores a 2017'
  };
  var GAMA_ALTA = ['BMW', 'Mercedes-Benz', 'Mercedes', 'Audi', 'Tesla', 'Porsche', 'Volvo', 'Land Rover', 'Jaguar', 'Lexus'];
  var OPACIDAD = '0.45';
  var SYNC = [];
  var enMemoria = null;
  function simplifica(L) { return L === 'P' ? 'H' : L; }
  var catalogo = {};

  /* ---------- datos ---------- */

  function normaliza(d) {
    var out = {};
    if (!d) return out;
    if (d.carr) { Object.keys(d.carr).forEach(function (k) { CARR[k] = d.carr[k]; }); }
    if (d.m) {
      var base = d.base || 2000, min = d.min || 0, v3 = (d.v || 1) >= 3;
      Object.keys(d.m).forEach(function (marca) {
        out[marca] = {};
        (d.m[marca] || []).forEach(function (f) {
          var ini = Math.max((f[1] || 0) + base, min), fin = (f[2] || 0) + base;
          var c = '', p = 'G';
          if (!v3 && f[3] && /^[GHPE]+$/.test(f[3])) { p = f[3]; }     /* v1/v2 */
          else if (f[3]) { c = f[3]; p = f[4] || 'G'; }
          var rg = (f[5] && typeof f[5] === 'object') ? f[5] : null;
          var ficha = { anios: [], carr: c, prop: p, rangos: rg, ini: ini, fin: fin };
          for (var y = fin; y >= ini; y--) if (motoresDe(ficha, y).length) ficha.anios.push(y);
          out[marca][f[0]] = ficha;
        });
      });
      return out;
    }
    Object.keys(d).forEach(function (marca) {
      var b = d[marca] || {};
      out[marca] = {};
      (b.modelos || []).forEach(function (mo) {
        out[marca][mo] = { anios: (b.anios || []).slice(), carr: '', prop: 'G', rangos: null };
      });
    });
    return out;
  }

  function propioDe(caja) {
    var tag = caja.querySelector('[data-hk-vehiculo-datos]');
    if (!tag) return {};
    try { return normaliza(JSON.parse(tag.textContent)); } catch (e) { return {}; }
  }

  function datosDe(caja) {
    var n = caja.hasAttribute('data-hk-lista-propia') ? propioDe(caja) : {};
    if (!Object.keys(n).length) { try { n = normaliza(window.HAKEN_VEHICULOS); } catch (e) { n = {}; } }
    if (!Object.keys(n).length) n = propioDe(caja);
    catalogo = n;
    return n;
  }

  /* ---------- reglas de negocio ---------- */

  function motoresDe(ficha, anio) {
    if (!ficha) return [];
    var rangos = ficha.rangos || {};
    var out = [];
    (ficha.prop || 'G').split('').forEach(function (L) {
      var tr = rangos[L];
      if (anio && tr && (anio < tr[0] + 2000 || anio > tr[1] + 2000)) return;
      var s = simplifica(L);
      if (out.indexOf(s) === -1) out.push(s);
    });
    return out;
  }

  function esGamaAlta(marca) {
    var lista = (window.HAKEN_GAMA_ALTA || GAMA_ALTA).map(function (m) { return String(m).trim().toLowerCase(); });
    return !!marca && lista.indexOf(marca.toLowerCase()) !== -1;
  }

  function lineaDe(anio, motor, marca) {
    if (!anio || !motor) return '';
    if (/[HPE]/.test(motor)) return 'Premium y EV';
    if (esGamaAlta(marca)) return 'Premium y EV';
    if (anio < (parseInt(window.HAKEN_CORTE, 10) || 2017)) return 'Modelos anteriores a 2017';
    return 'Línea Estándar';
  }
  function claveDe(v) {
    if (!v) return '';
    var l = lineaDe(v.anio, v.motor, v.marca);
    if (l === 'Premium y EV') return 'premium';
    if (l === 'Modelos anteriores a 2017') return 'anteriores';
    return 'estandar';
  }

  /* Origen del visitante: "Web" o "Web (Instagram)", "Web (Facebook)"...
     Usa ?utm_source= si existe; si no, el sitio de donde vino (referrer). */
  var FUENTES = [
    ['instagram', 'Instagram'], ['facebook', 'Facebook'], ['fb.', 'Facebook'], ['fb', 'Facebook'],
    ['messenger', 'Messenger'], ['whatsapp', 'WhatsApp'], ['wa.me', 'WhatsApp'],
    ['google', 'Google'], ['bing', 'Bing'], ['yahoo', 'Yahoo'], ['tiktok', 'TikTok'],
    ['youtube', 'YouTube'], ['youtu.be', 'YouTube'], ['twitter', 'X'], ['t.co', 'X'],
    ['linkedin', 'LinkedIn'], ['pinterest', 'Pinterest'], ['mercadolibre', 'Mercado Libre']
  ];
  function origen() {
    var src = '';
    try { src = new URLSearchParams(location.search).get('utm_source') || ''; } catch (e) {}
    if (!src && document.referrer) {
      try {
        var h = new URL(document.referrer).hostname.replace(/^www\./, '');
        if (h && h.indexOf(location.hostname.replace(/^www\./, '')) === -1 && h.indexOf('myshopify') === -1 && h.indexOf('shopify') === -1) src = h;
      } catch (e) {}
    }
    src = String(src || '').toLowerCase().trim();
    if (!src) return 'Web';
    var nombre = '';
    for (var i = 0; i < FUENTES.length; i++) {
      if (src === FUENTES[i][0] || src.indexOf(FUENTES[i][0]) !== -1) { nombre = FUENTES[i][1]; break; }
    }
    if (!nombre) {
      var partes = src.split('.');
      var base = partes.length > 1 ? (partes[0].length <= 2 && partes.length > 2 ? partes[1] : partes[0]) : src;
      base = base.replace(/[-_]+/g, ' ').slice(0, 20);
      nombre = base.charAt(0).toUpperCase() + base.slice(1);
    }
    return 'Web (' + nombre + ')';
  }

  /* ---------- guardar y leer el vehículo ---------- */

  function corto(v) { return v ? { marca: v.marca, modelo: v.modelo, anio: v.anio, motor: v.motor } : null; }

  function guarda(v) {
    enMemoria = v || null;
    try { v ? localStorage.setItem(LLAVE, JSON.stringify(v)) : localStorage.removeItem(LLAVE); } catch (e) {}
    try { v ? sessionStorage.setItem(LLAVE, JSON.stringify(v)) : sessionStorage.removeItem(LLAVE); } catch (e) {}
    enlaza(v);
  }

  /* Lee #hkv=... de la dirección (viene del enlace de la página anterior). */
  function deLaDireccion() {
    var m = (location.hash || '').match(/hkv=([^&]+)/);
    if (!m) return undefined;
    var v;
    try { v = m[1] === '0' ? null : JSON.parse(decodeURIComponent(m[1])); } catch (e) { return undefined; }
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    return v;
  }

  function recupera() {
    if (enMemoria !== null) return enMemoria;
    var s = null;
    try { s = localStorage.getItem(LLAVE); } catch (e) {}
    if (!s) { try { s = sessionStorage.getItem(LLAVE); } catch (e) {} }
    try { return JSON.parse(s || 'null'); } catch (e) { return null; }
  }

  /* Agrega el vehículo a los enlaces internos para que viaje a la siguiente página. */
  function enlaza(v) {
    var marca = v ? '#hkv=' + encodeURIComponent(JSON.stringify(corto(v))) : '#hkv=0';
    document.querySelectorAll('a[href]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/') return;
      var base = h.split('#')[0];
      var hash = h.indexOf('#') > -1 ? h.slice(h.indexOf('#')) : '';
      if (hash && hash.indexOf('#hkv=') !== 0) return;       /* anclas propias: no se tocan */
      a.setAttribute('href', base + marca);
    });
  }

  /* ---------- WhatsApp con el mensaje ya escrito ---------- */

  function productoDe(a, v) {
    var card = a.closest('[data-hk-tiron]');
    if (card && PRODUCTO_TIRON[card.getAttribute('data-hk-tiron')]) return PRODUCTO_TIRON[card.getAttribute('data-hk-tiron')];
    var propio = a.getAttribute('data-hk-producto');
    if (propio) return propio;
    if (document.querySelector('[data-hk-galeria]')) {
      var h1 = document.querySelector('h1');
      if (h1 && h1.textContent.trim()) return '"' + h1.textContent.trim().replace(/\s+/g, ' ') + '"';
    }
    if (v && PRODUCTO_TIRON[claveDe(v)]) return PRODUCTO_TIRON[claveDe(v)];
    return 'sus productos';
  }

  function servicioDe(a) {
    var s = a.getAttribute('data-hk-servicio');
    if (!s) {
      var card = a.closest('.hk-serv');
      var t = card && card.querySelector('.hk-serv__titulo');
      s = t ? t.textContent : '';
    }
    s = (s || '').trim().replace(/\s+/g, ' ');
    return s ? s.charAt(0).toLowerCase() + s.slice(1) : '';
  }

  function vehiculoTexto(v) {
    if (!v || !v.marca) return '';
    var comb = COMBUSTIBLE[simplifica(v.motor)] || '';
    return [v.marca, v.modelo, v.anio].join(' ') + (comb ? ' ' + comb : '');
  }

  function esAgenda(a) {
    var tipo = (a.getAttribute('data-hk-wa') || '').toLowerCase();
    if (tipo) return tipo === 'agenda';
    return /agendar|agenda tu|cita/i.test(a.textContent || '');
  }

  function mensaje(a, v) {
    var veh = vehiculoTexto(v);
    var cola = veh ? ' Mi vehículo es: ' + veh + '.' : '';
    var serv = servicioDe(a);
    if (serv) {
      return origen() + '\nBuenas, me gustaría agendar el servicio de ' + serv +
        '. ¿Me podría decir si esta semana tienen espacios disponibles?' + cola;
    }
    if (esAgenda(a)) {
      return origen() + '\nBuenas, ¿me podría decir si esta semana tienen espacios disponibles?' + cola;
    }
    var t = origen() + '\nHola, buen día. Me gustaría que me diera más información sobre ' + productoDe(a, v) + '.';
    if (veh) t += ' Mi vehículo es un ' + veh + '.';
    return t;
  }

  function armaWhatsApp(v) {
    var links = document.querySelectorAll('a[href*="wa.me/"], a[href*="api.whatsapp.com"]');
    if (!links.length) return;
    links.forEach(function (a) {
      if (!a.dataset.hkWaBase) a.dataset.hkWaBase = a.getAttribute('href').split('?')[0];
      a.setAttribute('href', a.dataset.hkWaBase + '?text=' + encodeURIComponent(mensaje(a, v)));
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
      if (!a.dataset.hkWaEvento) {
        a.dataset.hkWaEvento = '1';
        a.addEventListener('click', function (e) {
          if (a.closest('.is-atenuada')) { e.preventDefault(); return; }
          /* se arma de nuevo al momento del clic con el vehículo más reciente */
          a.setAttribute('href', a.dataset.hkWaBase + '?text=' + encodeURIComponent(mensaje(a, recupera())));
          if (window.gtag) window.gtag('event', 'contacto_whatsapp');
          if (window.fbq) window.fbq('track', 'Contact');
        });
      }
    });
  }

  /* ---------- ocultar lo que no aplica al vehículo ---------- */

  function cumple(el, v) {
    if (!v) return true;
    var lista = function (attr) {
      var s = el.getAttribute(attr);
      return s ? s.split('|').map(function (x) { return x.trim(); }).filter(Boolean) : null;
    };
    var lin = lista('data-hk-linea');
    if (lin && lin.indexOf(v.linea || lineaDe(v.anio, v.motor, v.marca)) === -1) return false;
    var car = lista('data-hk-carroceria');
    if (car && car.indexOf(v.carroceria) === -1) return false;
    var pro = lista('data-hk-propulsion');
    if (pro && !pro.some(function (p) { return (v.propulsion || '').indexOf(p) !== -1; })) return false;
    var mot = lista('data-hk-motor');
    if (mot && mot.indexOf(v.motor) === -1) return false;
    var min = el.getAttribute('data-hk-anio-min');
    if (min && v.anio < parseInt(min, 10)) return false;
    var max = el.getAttribute('data-hk-anio-max');
    if (max && v.anio > parseInt(max, 10)) return false;
    return true;
  }

  function filtra(v) {
    var els = document.querySelectorAll('[data-hk-linea], [data-hk-carroceria], [data-hk-propulsion], [data-hk-motor], [data-hk-anio-min], [data-hk-anio-max]');
    var ocultos = 0;
    els.forEach(function (el) {
      var ok = cumple(el, v);
      el.classList.toggle('hk-oculto', !ok);
      if (!ok) ocultos++;
    });
    document.querySelectorAll('[data-hk-sin-resultados]').forEach(function (el) {
      el.classList.toggle('hk-oculto', !(v && els.length && ocultos === els.length));
    });
  }

  /* ---------- tarjetas de tirón ---------- */

  function marcaTirones(v) {
    var clave = claveDe(v);
    document.querySelectorAll('[data-hk-tiron]').forEach(function (c) {
      var suya = c.getAttribute('data-hk-tiron');
      var es = !!v && suya === clave;
      var otra = !!v && suya !== clave;
      c.classList.toggle('is-recomendada', es);
      c.classList.toggle('is-atenuada', otra);
      c.style.transition = 'opacity .25s ease, outline-color .25s ease';
      c.style.opacity = otra ? OPACIDAD : '';
      c.style.outline = es ? '3px solid #DA291C' : '';
      c.style.outlineOffset = es ? '3px' : '';
      c.querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp.com"]').forEach(function (a) {
        if (otra) { a.setAttribute('aria-disabled', 'true'); a.setAttribute('tabindex', '-1'); }
        else { a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex'); }
      });
      var vieja = c.querySelector('.hk-guia__marca');
      if (vieja) vieja.remove();
      if (es) {
        var t = c.querySelector('.hk-card__titulo');
        if (t) {
          var eti = document.createElement('span');
          eti.className = 'hk-guia__marca';
          eti.textContent = 'Recomendado para ti';
          eti.setAttribute('style', "display:table;background:#DA291C;color:#FAF8F4;font-family:'Barlow Condensed',sans-serif;font-size:11.5px;letter-spacing:.2em;text-transform:uppercase;padding:5px 10px;margin-bottom:10px");
          t.parentNode.insertBefore(eti, t);
        }
      }
    });
  }

  /* ---------- selector ---------- */

  function avisa(v) {
    guarda(v);
    marcaTirones(v);
    armaWhatsApp(v);
    filtra(v);
    document.dispatchEvent(new CustomEvent('haken:vehiculo', { detail: v }));
  }

  function initVehiculo(scope) {
    scope.querySelectorAll('[data-hk-vehiculo]').forEach(function (caja) {
      try { iniciaCaja(caja); } catch (e) { if (window.console) console.error('Haken selector:', e); }
    });
  }

  function iniciaCaja(caja) {
      caja.removeAttribute('data-hk-vehiculo');
      caja.setAttribute('data-hk-vehiculo-listo', '');

      var datos = datosDe(caja);
      var marca = caja.querySelector('[data-hk-marca]');
      var modelo = caja.querySelector('[data-hk-modelo]');
      var anio = caja.querySelector('[data-hk-anio]');
      if (!marca || !modelo || !anio) return;
      [marca, modelo, anio].forEach(function (s) { s.setAttribute('autocomplete', 'off'); });

      var motor = caja.querySelector('[data-hk-motor-select]');
      if (!motor) {
        var campoAnio = anio.closest('label') || anio.parentNode;
        var campo = document.createElement('label');
        campo.className = campoAnio.className || 'hk-campo';
        campo.setAttribute('data-hk-campo-motor', '');
        campo.innerHTML = '<span>Versión</span><select class="' + anio.className +
          '" data-hk-motor-select disabled><option value="">Elige versión</option></select>';
        campoAnio.parentNode.insertBefore(campo, campoAnio.nextSibling);
        motor = campo.querySelector('[data-hk-motor-select]');
      }
      motor.setAttribute('autocomplete', 'off');
      var campoMotor = motor.closest('[data-hk-campo-motor]') || motor.parentNode;
      campoMotor.classList.remove('hk-oculto');

      var aviso = caja.querySelector('[data-hk-compat]');
      var selBoton = caja.getAttribute('data-hk-boton');
      var boton = null;
      if (selBoton) { try { boton = document.querySelector(selBoton); } catch (e) { boton = null; } }
      var textoOk = caja.getAttribute('data-hk-texto-ok') || 'Pieza confirmada para {v}.';
      var textoListo = boton ? boton.getAttribute('data-hk-texto-listo') : null;
      var textoEspera = boton ? boton.textContent.trim() : null;

      function opcion(v, t) { var o = document.createElement('option'); o.value = v; o.textContent = t; return o; }
      function limpiar(sel, ph) { sel.innerHTML = ''; sel.appendChild(opcion('', ph)); }

      limpiar(marca, 'Elige marca');
      Object.keys(datos).sort(function (a, b) { return a.localeCompare(b, 'es'); })
        .forEach(function (m) { marca.appendChild(opcion(m, m)); });

      function pintaModelos() {
        limpiar(modelo, 'Elige modelo');
        modelo.disabled = !marca.value;
        if (marca.value && datos[marca.value]) {
          Object.keys(datos[marca.value]).sort(function (a, b) { return a.localeCompare(b, 'es'); })
            .forEach(function (mo) { modelo.appendChild(opcion(mo, mo)); });
        }
      }
      function pintaAnios() {
        limpiar(anio, 'Elige año');
        anio.disabled = !modelo.value;
        var ficha = marca.value && modelo.value && datos[marca.value] ? datos[marca.value][modelo.value] : null;
        if (ficha) ficha.anios.forEach(function (a) { anio.appendChild(opcion(a, a)); });
      }

      function fichaDe() {
        return marca.value && modelo.value && datos[marca.value] ? datos[marca.value][modelo.value] : null;
      }
      function opcionesMotor() {
        var f = fichaDe();
        var a = parseInt(anio.value, 10);
        return f && a ? motoresDe(f, a) : [];
      }
      function pintaMotores() {
        var previo = motor.value;
        limpiar(motor, 'Elige versión');
        var ops = opcionesMotor();
        ops.forEach(function (p) { motor.appendChild(opcion(p, MOTOR[p] || p)); });
        if (ops.length === 1) motor.value = ops[0];
        else if (previo && ops.indexOf(previo) !== -1) motor.value = previo;
        motor.disabled = ops.length < 2;
      }

      marca.addEventListener('change', function () { pintaModelos(); pintaAnios(); pintaMotores(); evaluar(); });
      modelo.addEventListener('change', function () { pintaAnios(); pintaMotores(); evaluar(); });
      anio.addEventListener('change', function () { pintaMotores(); evaluar(); });
      motor.addEventListener('change', evaluar);

      function evaluar() {
        var ficha = fichaDe();
        var ops = opcionesMotor();
        var elegido = ops.length > 1 ? motor.value : (ops[0] || '');
        var listo = !!(marca.value && modelo.value && anio.value && elegido);
        var texto = listo ? (marca.value + ' ' + modelo.value + ' ' + anio.value) : '';
        var v = listo ? {
          marca: marca.value,
          modelo: modelo.value,
          anio: parseInt(anio.value, 10),
          carroceria: ficha ? ficha.carr : '',
          carroceriaTexto: ficha && CARR[ficha.carr] ? CARR[ficha.carr] : '',
          propulsion: ficha ? ficha.prop : '',
          motor: elegido,
          motorTexto: MOTOR[elegido] || '',
          linea: lineaDe(parseInt(anio.value, 10), elegido, marca.value),
          texto: texto + ' (' + (MOTOR[elegido] || '') + ')'
        } : null;

        if (aviso) {
          aviso.classList.toggle('is-ok', listo);
          aviso.textContent = listo
            ? textoOk.replace('{v}', v.texto) + (v.linea ? ' ' + v.linea + '.' : '')
            : (aviso.getAttribute('data-hk-espera') || aviso.textContent);
        }
        if (boton) {
          boton.disabled = !listo;
          if (textoListo) boton.textContent = listo ? textoListo : textoEspera;
        }
        document.querySelectorAll('[data-hk-vehiculo-campo]').forEach(function (campo) { campo.value = listo ? v.texto : ''; });
        avisa(v);
      }

      function aplica(p) {
        if (p && datos[p.marca] && datos[p.marca][p.modelo]) {
          marca.value = p.marca; pintaModelos();
          modelo.value = p.modelo; pintaAnios();
          var a = parseInt(p.anio, 10);
          if (datos[p.marca][p.modelo].anios.indexOf(a) !== -1) anio.value = String(a);
          pintaMotores();
          if (p.motor && !motor.disabled) motor.value = simplifica(p.motor);
          evaluar();
        } else if (p) {
          pintaMotores();
          guarda(p);
          marcaTirones(p);
          armaWhatsApp(p);
          document.dispatchEvent(new CustomEvent('haken:vehiculo', { detail: p }));
        } else {
          marca.value = '';
          pintaModelos(); pintaAnios(); pintaMotores();
          evaluar();
        }
      }

      modelo.disabled = true; anio.disabled = true;
      aplica(recupera());
      SYNC.push(aplica);
  }

  function sincroniza() {
    enMemoria = null;
    var p = recupera();
    if (SYNC.length) SYNC.forEach(function (f) { try { f(p); } catch (e) {} });
    else { enlaza(p); marcaTirones(p); armaWhatsApp(p); filtra(p); }
  }

  window.HakenVehiculo = {
    get: recupera,
    limpiar: function () { guarda(null); sincroniza(); },
    origen: origen,
    linea: lineaDe,
    catalogo: function () {
      if (!Object.keys(catalogo).length) catalogo = normaliza(window.HAKEN_VEHICULOS);
      return catalogo;
    }
  };

  function init(scope) {
    scope = scope || document;
    initVehiculo(scope);
    if (!document.querySelector('[data-hk-vehiculo-listo]')) {
      var v = recupera();
      enlaza(v);
      marcaTirones(v);
      armaWhatsApp(v);
      filtra(v);
    }
  }

  /* Si el vehículo llegó en el enlace, manda sobre lo guardado */
  (function () {
    var d = deLaDireccion();
    if (d !== undefined) {
      try { d ? localStorage.setItem(LLAVE, JSON.stringify(d)) : localStorage.removeItem(LLAVE); } catch (e) {}
      try { d ? sessionStorage.setItem(LLAVE, JSON.stringify(d)) : sessionStorage.removeItem(LLAVE); } catch (e) {}
      enMemoria = d;
    }
  })();

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) sincroniza(); });
  window.addEventListener('storage', function (e) { if (e.key === LLAVE) sincroniza(); });
})();
